import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {refreshBaseQuery} from './refreshBaseQuery'
const API_URL = process.env.REACT_APP_API_URL

export const mailServiceApi = createApi({
  reducerPath: 'mailServiceApi',
  baseQuery: refreshBaseQuery,
  endpoints: (builder) => ({
    sendInvitationByEmail: builder.mutation({
      query: ({email, company_name}) => ({
        url: '/mail/send-invitation-email',
        method: 'POST',
        body: {email, company_name},
      }),
    }),
    getInvitationLink: builder.mutation({
      query: (company_name) => ({
        url: '/mail/request_link',
        method: 'POST',
        body: {company_name},
      }),
    }),
  }),
})

export const {useSendInvitationByEmailMutation, useGetInvitationLinkMutation} = mailServiceApi
